export const IS_LOCAL = process.env.ENVIRONMENT === 'local'
export const IS_PRODUCTION = process.env.ENVIRONMENT === 'production'

let site_url = `https://${process.env.SUB_DOMAIN}.buoyhealth.com`
let api_url = '/api/'

if (IS_LOCAL) {
  site_url = "http://localhost:8080"
  api_url = "http://localhost:8001/api/"
}

// During Gatsby build, 'window' is not available, so we have to set this value
// in componentDidMount of pages
export const setBaseUrl = () => {
  // override site_url from componentDidMount
  BUOY_SITE_URL = window.location.origin
}

export let BUOY_SITE_URL = site_url
export const BUOY_API_BASE = api_url



// WEBPACK FOOTER //
// ./src/common/constants.js